import { styled } from '@mui/material/styles';

export const RadarRadiusValue = styled('text')(({ theme }) => ({
  fill: theme.palette.primary.light,
  textAnchor: 'middle',
  dominantBaseline: 'middle',
  fontSize: 20,
}));
